import {Component, OnInit, TemplateRef} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APIHelper} from "../../../apihelper";
import {SharedResources} from "../../../shared-resources";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ViewChild} from '@angular/core';
import {NgbModal, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject, merge, OperatorFunction} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';

@Component({
  selector: 'app-input-order',
  templateUrl: './input-order.component.html',
  styleUrls: ['./input-order.component.css']
})
export class InputOrderComponent implements OnInit {

  @ViewChild('instance', {static: true}) instance: any;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  incoterms : string[] = [];
  partnumbers : string[] = [];
  currentPartNumber : string = '';
  currentQuantity: number = 0;
  currentModifiablePartNo: string = '';
  currentModifiablePartName: string = '';
  lines : Map<string, number> = new Map<string, number>();
  linesCountries : Map<string, string> = new Map<string, string>();
  linesDetails : Map<string, any> = new Map<string, any>();
  currentSN: string = '';
  currentOrderPageSN: any;
  numberOfOrderPagesSN: any;
  currentMAC: string = '';
  numberOfOrderPagesMAC: any;
  currentOrderPageMAC: any;
  currentModifiableQuantity: any;
  currentCountryOfExpedition: any = "";
  currentModifiableCountryOfExpedition: any;
  countries : any = [];
  parts: any = [];
  currentPart: string = '';
  backupLineDetail : any = {
    "details" : {}
  };
  ordersForm = new FormGroup(
    {
      Id: new FormControl(''),
      PO: new FormControl('',
        [
          Validators.required,
          Validators.pattern('^PO[0-9]+$')
        ]),
      NumarFactura: new FormControl('',
        [
          Validators.required
        ]),
      DataReceptie: new FormControl('',
        [
          Validators.required
        ]),
      ConditieLivrare: new FormControl('',
        [
          Validators.required
        ])
    }
  )


  constructor(private http: HttpClient, private modalService: NgbModal) {
  }

  ngOnInit(): void {

    this.ordersForm.controls.Id.setValue('00000000-0000-0000-0000-000000000000');
    this.http.get<any>(`${APIHelper.APIUrl}country`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.countries = response.map((t : any) => t.Nume + ' (' + t.Cod + ')').sort((t1: any, t2: any) => {
          return t1.localeCompare(t2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea țărilor!");
        SharedResources._isLoadingBS.next(false);
      });
    this.http.get<any>(`${APIHelper.APIUrl}partnumber`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.partnumbers = response.map((pn : string) => pn.toUpperCase()).sort((pn1: any, pn2: any) => {
          return pn1.localeCompare(pn2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea listei de produse!");
        SharedResources._isLoadingBS.next(false);
      });


    this.http.get<any>(`${APIHelper.APIUrl}incoterm`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.incoterms = response.map((i : any) => i.Nume).sort((i1: any, i2: any) => {
          return i1.localeCompare(i2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea condițiilor de livrare!");
        SharedResources._isLoadingBS.next(false);
      });
  }

  cancelAddOrder() {
    SharedResources.currentScreen = 'orders';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  addOrder(inputOrderForm: any) {
    SharedResources._isLoadingBS.next(true);

    this.http.post<any>(`${APIHelper.APIUrl}order`,
      inputOrderForm.value,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.http.post<any>(`${APIHelper.APIUrl}orderdetail`,
          {
            OrderId : response.Id,
            OrderLineCodes : this.getOrderLineCodes()
          },
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('token')}`
            })
          }).subscribe((response: any) => {
            alert("Comandă creată cu succes!");
            SharedResources._isLoadingBS.next(false);
            SharedResources._currentScreenBS.next('orders');
        }, (error : any) => {
          alert(error.error);
          SharedResources._isLoadingBS.next(false);
        });
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }
  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.partnumbers
        : this.partnumbers.filter((v : any)=> v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );
  }





  addLine() {
    if (!this.partnumbers.map((pn : string) => pn.toUpperCase()).includes(this.currentPartNumber.toUpperCase())) {
      alert("Part Number-ul introdus nu există!");
      return;
    }
    if (this.currentQuantity <= 0) {
      alert("Cantitatea introdusă nu este validă!");
      return;
    }
    if (this.currentCountryOfExpedition === '') {
      alert("Țara de expediție introdusă nu este validă!");
      return;
    }
    if (this.lines.has(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())) {
      if (confirm(`Există deja o linie cu Part Number-ul ${this.currentPartNumber}${(this.currentPart == '' || this.currentPart == null) ? '' : (', piesa ' + this.currentPart)}, Cantitatea ${this.lines.get(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())} și Țara de Expediție ${this.linesCountries.get(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase())}. Doriți actualizarea datelor liniei?`)) {
        this.lines.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentQuantity);
        this.linesCountries.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentCountryOfExpedition);
        this.currentCountryOfExpedition = '';
        this.currentPartNumber = '';
        this.currentPart = '';
        this.currentQuantity = 0;
      }
      return;
    }
    this.lines.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentQuantity);
    this.linesCountries.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), this.currentCountryOfExpedition);
    this.linesDetails.set(this.currentPartNumber.toUpperCase() + '\t' + this.currentPart.toUpperCase(), {"mac": [], "sn": []});
    this.currentCountryOfExpedition = '';
    this.currentPartNumber = '';
    this.currentPart = '';
    this.currentQuantity = 0;
  }


  modifyLineDetails(modalLinesDetails: TemplateRef<any>, partNo: string, partName: string) {
    this.currentModifiablePartNo = partNo.toUpperCase();
    this.currentModifiablePartName = partName.toUpperCase();
    this.backupLineDetail.number = JSON.parse(JSON.stringify(this.lines.get(partNo.toUpperCase() + '\t' + partName.toUpperCase())));
    this.backupLineDetail.details = JSON.parse(JSON.stringify(this.linesDetails.get(partNo.toUpperCase() + '\t' + partName.toUpperCase())));
    this.currentModifiableCountryOfExpedition = this.linesCountries.get(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    this.currentOrderPageSN = 1;
    this.numberOfOrderPagesSN = this.backupLineDetail.details.sn.length % 3 == 0 ?
      Math.floor(this.backupLineDetail.details.sn.length / 3) : (Math.floor(this.backupLineDetail.details.sn.length / 3) + 1);
    this.currentOrderPageMAC = 1;
    this.numberOfOrderPagesMAC = this.backupLineDetail.details.mac.length % 3 == 0 ?
      Math.floor(this.backupLineDetail.details.mac.length / 3) : (Math.floor(this.backupLineDetail.details.mac.length / 3) + 1);
    this.currentModifiableQuantity = this.lines.get(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    this.modalService.open(modalLinesDetails, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard:false}).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  deleteLine(partNo: string, partName: string) {
    if (confirm(`Sunteți sigur(ă) ca doriți să ștergeți linia cu Part Number-ul ${partNo}? (Toate datele asociate vor fi șterse)`)) {
      this.lines.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
      this.linesDetails.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
      this.linesCountries.delete(partNo.toUpperCase() + '\t' + partName.toUpperCase());
    }
  }

  applyLinesDetailsModifications(modalLinesDetails: any) {
    if (this.currentModifiableQuantity <= 0) {
      alert("Cantitatea introdusă nu este validă");
      return;
    }
    this.lines.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.currentModifiableQuantity);
    this.linesCountries.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.currentModifiableCountryOfExpedition);
    modalLinesDetails.dismiss();
  }

  restoreLinesDetailsModifications(modalLinesDetails: any) {
    //this.lines.set(this.currentModifiablePartNo.toUpperCase(), this.backupLineDetail.number);
    this.linesDetails.set(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase(), this.backupLineDetail.details);
    modalLinesDetails.dismiss();
  }

  deleteSN(sn: any) {
    this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.splice(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.indexOf(sn), 1);
    this.numberOfOrderPagesSN = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length % 3 == 0 ?
      Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) + 1);
    if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
      this.currentOrderPageSN = 1;
    }
  }

  addSN() {
    if (this.currentSN == "") {
      alert("Câmpul de serial number nu a fost completat!");
      return;
    }
    let addedSN = this.currentSN.split(' ').filter((s : any) => s != '');
    for (let s of addedSN) {
      if (!this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.map((sn : string) => sn.toUpperCase()).includes(s.toUpperCase())) {
        this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.push(s.toUpperCase());

        this.numberOfOrderPagesSN = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length % 3 == 0 ?
          Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.length / 3) + 1);
      }
    }
    this.currentSN = '';
  }

  getSNPage() {
    return this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).sn.filter(
      (value: number, index:number) => index >= (this.currentOrderPageSN - 1) * 3 && index <= this.currentOrderPageSN * 3 - 1);
  }


  goToNextPageSN() {
    this.currentOrderPageSN++;
    if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
      this.currentOrderPageSN = 1;
    }
  }

  goToPrevPageSN() {
    this.currentOrderPageSN--;
    if (this.currentOrderPageSN == 0) {
      this.currentOrderPageSN = this.numberOfOrderPagesSN;
    }
  }

  addMAC() {
    if (this.currentMAC == "") {
      alert("Câmpul de MAC nu a fost completat!");
      return;
    }

    let addedMacs = this.currentMAC.split(' ').filter((m : any) => m != '');

    for (let m of addedMacs) {
      if (!this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.map((mac : string) => mac.toUpperCase()).includes(m.toUpperCase())) {
        this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.push(m.toUpperCase());
        this.numberOfOrderPagesMAC = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length % 3 == 0 ?
          Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) + 1);
      }
    }
    this.currentMAC = '';
  }

  getMACPage() {
    return this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.filter(
      (value: number, index:number) => index >= (this.currentOrderPageMAC - 1) * 3 && index <= this.currentOrderPageMAC * 3 - 1);
  }

  deleteMAC(mac: any) {
    this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.splice(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.indexOf(mac), 1);
    this.numberOfOrderPagesMAC = this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length % 3 == 0 ?
      Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) : (Math.floor(this.linesDetails.get(this.currentModifiablePartNo.toUpperCase() + '\t' + this.currentModifiablePartName.toUpperCase()).mac.length / 3) + 1);
    if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
      this.currentOrderPageMAC = 1;
    }
  }

  goToPrevPageMAC() {
    this.currentOrderPageMAC--;
    if (this.currentOrderPageMAC == 0) {
      this.currentOrderPageMAC = this.numberOfOrderPagesMAC;
    }
  }

  goToNextPageMAC() {
    this.currentOrderPageMAC++;
    if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
      this.currentOrderPageMAC = 1;
    }
  }

  getOrderLineCodes() {
    let returnValue = [];
    for (let i of this.lines) {
      let orderLineCodes = {
        PartNo : i[0].split('\t')[0],
        Cantitate: i[1],
        TaraExpediere: this.linesCountries.get(i[0]),
        PartName: i[0].split('\t')[1],
        SN: this.linesDetails.get(i[0]).sn.map((s : any) => {
          return {
            Item1: s,
            Item2: null,
            Item3: null
          }
        }),
        MAC: this.linesDetails.get(i[0]).mac.map((m : any) => {
          return {
            Item1: m,
            Item2: null,
            Item3: null
          }
        })
      }
      returnValue.push(orderLineCodes);
    }
    return returnValue;
  }
  refreshParts() {
    this.http.get<any>(`${APIHelper.APIUrl}part?partNo=${encodeURIComponent(this.currentPartNumber)}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.parts = response.map((r: any) => r.Nume);
      }, (error: any) => {
      });
  }
}
